import { makeObservable, observable, action } from 'mobx';

export type GoalType =
  | 'improveFitness'
  | 'loseWeight'
  | 'increaseEndurance'
  | 'increaseSpeed'
  | 'boostMentalStrength'
  | 'relieveStress';

export type GoalOptionType = {
  title: string;
  value: GoalType;
  image: string;
};
export class GoalsStore {
  selectedGoals: Set<GoalType> = new Set();

  goalOptions: GoalOptionType[] = [
    { title: 'Improve fitness', value: 'improveFitness', image: '💪' },
    { title: 'Increase endurance', value: 'increaseEndurance', image: '🏃' },
    {
      title: 'Boost mental strength',
      value: 'boostMentalStrength',
      image: '🧠',
    },
    { title: 'Lose weight', value: 'loseWeight', image: '🍏' },
    { title: 'Relieve stress', value: 'relieveStress', image: '🌿' },
    { title: 'Increase speed', value: 'increaseSpeed', image: '💨' },
  ];

  shuffledGoals = this.shuffleGoals();

  constructor() {
    makeObservable(this, {
      selectedGoals: observable,
      toggleGoal: action,
      goalOptions: observable,
      shuffleGoals: action,
    });
  }

  toggleGoal(inputGoal: GoalType) {
    if (this.selectedGoals.has(inputGoal)) {
      this.selectedGoals.delete(inputGoal);
    } else {
      this.selectedGoals.add(inputGoal);
    }
  }

  shuffleGoals() {
    const newArr = [...this.goalOptions];
    for (let i = this.goalOptions.length - 1; i > 0; i -= 1) {
      const j = Math.floor(Math.random() * (i + 1));
      [newArr[i], newArr[j]] = [newArr[j], newArr[i]];
    }
    this.goalOptions = [...newArr];
  }
}

export const goalsStore = new GoalsStore();
